import script from "./ButtonSecondary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonSecondary.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__